export const USER_ROLES = [
    "OWNER",
    "ADMIN",
    "RECEPTION",
    "CASHIER",
    "WAITER",
    "CUSTOMER",
];
export const BOOKING_STATUSES = [
    "PENDING",
    "CONFIRMED",
    "CANCELLED",
    "COMPLETED",
    "NO_SHOW",
];
export const BOOKING_SOURCES = ["WEB", "APP", "WHATSAPP", "ADMIN"];
export const ORDER_STATUSES = ["OPEN", "PREPARING", "READY", "DELIVERED", "CANCELLED", "PAID"];
export const CASH_SESSION_STATUSES = ["OPEN", "CLOSED"];
export function formatMoney(cents) {
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
    }).format(cents / 100);
}
export { TOURNAMENT_SPORTS, tournamentSportLabels, groupQualifiers, tournamentStages, stageRules, stageAdvancers, isPowerOfTwo, matchFormat, matchFormatLabel, defaultMatchFormat, setTarget, bestThirdStandings, extraQualifierStandings, extraQualifierCount, directQualifierCount, compareTournamentStandings } from './tournaments.js';
